<template>
  <a @click="click()" class="logo" href="#">
    <img src="/modules/custom/vue_apps/assets/source/static/images/logo.svg">
  </a>
</template>
<script>

export default {
  methods: {
    click () {
      this.$emit('click')
      this.$router.push('/')
      return false
    }
  }
}
</script>

<style lang="scss">
.logo {
  cursor: pointer;
  width: 307px;
  padding: 0px;
  margin: 0px;
  top: 30px;
  position: absolute;
  left: 30px;
  transition: left .5s ease;
  z-index: 100;
  overflow: hidden;
  display: block;
  &.only-img {
    width: 100px;
  }
  img {
    width: 100%;
  }
}
</style>